import React from 'react';
import { Building2, ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function WorkspaceSummary({ showLink = false }) {
  const { user } = useAuth();
  const isOwner = user?.role === 'owner';
  const name = user?.workspaceCompanyName || (isOwner && user?.businessName) || 'Your workspace';
  return <section aria-label="Current workspace" className="rounded-xl border border-primary-200 bg-primary-50 p-4 space-y-3">
    <div className="flex items-start gap-3">
      <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-white text-primary-700"><Building2 aria-hidden="true" className="h-6 w-6" /></div>
      <div className="min-w-0 flex-1"><p className="text-xs font-medium text-primary-700">Current workspace</p><h3 className="mt-1 break-words text-lg font-semibold text-gray-900">{name}</h3></div>
      <span className="shrink-0 rounded-full bg-white px-2.5 py-1 text-xs font-semibold text-primary-800">{isOwner ? 'Owner' : 'Member'}</span>
    </div>
    <p className="text-sm leading-6 text-gray-700">Your business’s shared contacts, enquiries, conversations, and tasks live here.</p>
    <p className="text-sm text-gray-600">{isOwner ? 'You manage this workspace, its team, and its subscription.' : 'Your workspace owner manages invitations, permissions, and billing.'}</p>
    {showLink && <Link to="/settings/workspace" className="inline-flex min-h-[44px] items-center gap-2 text-sm font-semibold text-primary-700">{isOwner ? 'Manage workspace' : 'View workspace'}<ChevronRight aria-hidden="true" className="h-4 w-4" /></Link>}
  </section>;
}
